import { makeAutoObservable, runInAction } from 'mobx';
import router from 'next/router';
import { signOut } from 'next-auth/react';
import logger from '@utils/logger';
import fetchNext from '@features/api/fetchNext';
import { IFetchedCustomerData, ICustomerAddress } from '@features/customerData/typescript';
import NextCheckoutApi from '@features/api/nextApiService/nextCheckoutApi';
import { ISessionCustomerData } from '@features/checkout/typescript';
export default class CustomerDataStore {
  public email = '';
  public id = '';
  public phoneNumber = '';
  public username = '';
  public firstName = '';
  public lastName = '';
  public addresses: Array<ICustomerAddress> = [];
  public isGuest = true;
  public isFetchingInProgress = false;
  constructor() {
    makeAutoObservable(this);
  }
  public fetchAndPopulateCustomerDataStore = async () => {
    const data = await this.fetchData();
    await runInAction(async () => {
      this.resetStore();
      this.populateStoreWithData(data);
      await this.saveCustomerInSession();
    });
  };
  private fetchData = async () => {
    try {
      runInAction(() => {
        this.isFetchingInProgress = true;
      });
      const {
        locale
      } = router;
      const {
        json: customerData
      } = await fetchNext('customer', {
        method: 'GET'
      }, locale?.toLocaleLowerCase());

      // const responseCustomerAddresses = await fetchNext(
      //   'customer/addresses',
      //   { method: 'GET' },
      //   locale?.toLocaleLowerCase(),
      // );
      // const customerAddresses = await responseCustomerAddresses.json();

      if (!Object.keys(customerData).length) {
        logger.error('Fetched no customer data');
        signOut({
          callbackUrl: '/'
        });
        this.removeCustomerFromSession();
      }
      // if (!customerAddresses.length) {
      //   logger.error('Fetched no customer addresses data');
      // }
      //
      // customerData.addresses = customerAddresses;

      runInAction(() => {
        this.isFetchingInProgress = false;
      });
      return customerData;
    } catch (error) {
      logger.error(error);
      runInAction(() => {
        this.isFetchingInProgress = false;
      });
      throw new Error(error as string);
    }
  };
  private resetStore = () => {
    this.email = '';
    this.id = '';
    this.phoneNumber = '';
    this.username = '';
    this.firstName = '';
    this.lastName = '';
    this.addresses = [];
    this.isGuest = true;
  };
  private populateStoreWithData = (customerData: IFetchedCustomerData) => {
    Object.keys(customerData).forEach(key => {
      if (this[key] === undefined || !customerData[key] || !customerData[key].length) return;
      if (typeof customerData[key] === 'string') {
        this[key] = customerData[key];
      }
      if (key === 'addresses') {
        this[key] = customerData[key];
      }
    });
  };
  private saveCustomerInSession = async () => {
    if (typeof window === 'undefined') return;
    const sessionCustomerData: ISessionCustomerData = {
      customerID: this.id,
      email: this.email
    };
    await NextCheckoutApi.setSessionCustomerData(sessionCustomerData);
    runInAction(() => {
      this.isGuest = false;
    });
  };
  public removeCustomerFromSession = async () => {
    if (typeof window === 'undefined') return;
    const emptySessionCustomerData: ISessionCustomerData = {} as ISessionCustomerData;
    await NextCheckoutApi.setSessionCustomerData(emptySessionCustomerData);
    runInAction(() => {
      this.isGuest = true;
    });
  };
  public getCustomerFromSession = async () => {
    if (typeof window === 'undefined') return false;
    const {
      success,
      data
    } = await NextCheckoutApi.getSessionCustomerData();
    if (!success || !data) return false;
    runInAction(() => {
      this.id = data.customerID;
      this.email = data.email;
    });
    return true;
  };
  public setProperty = (key: string, value: string | boolean) => {
    this[key] = value;
  };
  public setCustomerData = async (customerID: string, email: string) => {
    this.id = customerID;
    this.email = email;
    await this.saveCustomerInSession();
  };
  public resetAddresses = () => {
    this.addresses = [];
  };
}